type Coordinates = {
	lat: number;
	lon: number;
};

const DEFAULT_LOCATION_TIMEOUT_MS = 12000;

export const getCurrentCoordinates = async (): Promise<Coordinates> => {
	if (!navigator.geolocation) {
		throw new Error('このブラウザは位置情報APIに対応していません');
	}

	const position = await new Promise<GeolocationPosition>((resolve, reject) => {
		navigator.geolocation.getCurrentPosition(resolve, reject, {
			enableHighAccuracy: true,
			timeout: DEFAULT_LOCATION_TIMEOUT_MS,
			maximumAge: 0,
		});
	});

	return {
		lat: Number(position.coords.latitude.toFixed(6)),
		lon: Number(position.coords.longitude.toFixed(6)),
	};
};

export const reverseGeocodeToAreaHint = async (
	coordinates: Coordinates,
): Promise<string> => {
	const url = new URL('https://nominatim.openstreetmap.org/reverse');
	url.searchParams.set('lat', String(coordinates.lat));
	url.searchParams.set('lon', String(coordinates.lon));
	url.searchParams.set('format', 'jsonv2');
	url.searchParams.set('accept-language', 'ja');

	const response = await fetch(url.toString(), {
		headers: {
			Accept: 'application/json',
		},
	});

	if (!response.ok) {
		throw new Error('現在地の地名変換に失敗しました');
	}

	const json = await response.json();
	const address = json?.address ?? {};

	const area =
		address.neighbourhood ||
		address.suburb ||
		address.city_district ||
		address.quarter ||
		address.town ||
		address.city ||
		address.state;

	if (area && typeof area === 'string') {
		return area;
	}

	if (json?.display_name && typeof json.display_name === 'string') {
		return json.display_name.split(',')[0]?.trim() || '現在地付近';
	}

	return '現在地付近';
};
